import {
  Component,
  Input,
  OnInit,
  Output,
  HostListener,
  ElementRef,
  ViewChild
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

// import { DbService } from 'src/app/service/db.service';
import { ModalController } from '@ionic/angular';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.page.html',
  styleUrls: ['./add-address.page.scss'],
})
export class AddAddressPage implements OnInit {

  @Output() customer_id: any;
  @Output() customer_data: any;
  @Output() address_type: any;
  @Output() address_info: any = {};
  submitted = false;
  country_list: any = [];
  states_list: any = [];
  address_form:any = FormGroup;
  phone_pattern:any
  focus :any = {};
  @Input() is_modal;
  @ViewChild('addresstext') addresstext!: ElementRef;
  
  constructor(public db: DataService, public formBuilder: FormBuilder, public modalCtrl: ModalController) {
  }

  ngOnInit() {  
    // console.log(this.address_info);
    // console.log(this.customer_id);
    // console.log(this.address_type);
    this.db.check_mobile();
    this.get_country_list();
    if(this.db.currency == 'USD')
      this.phone_pattern = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/
    else
      this.phone_pattern = /^((\\+91-?) |0)?[0-9]{10}$/
    if (this.address_type == "Add") {
      this.address_info.first_name = this.customer_id.first_name ? this.customer_id.first_name : this.customer_id.phone;
      this.address_info.last_name = this.customer_id.last_name || "";
      this.address_info.address = "";
  		this.address_info.city = localStorage['city'] ? localStorage['city'] : "";//'Coimbatore';
      this.address_info.state = this.db.location_info.state ? this.db.location_info.state : '';//e,//   
  		this.address_info.zipcode = localStorage['zipcode'] ? localStorage['zipcode'] : '';//this.db.location_info.zipcode//this.address;
      this.address_info.house_type = "Individual";
      this.address_info.country =  ''
      this.address_info.landmark = ''
      this.address_info.door_no = ''
      this.address_info.is_default = false
      this.db.location_info.address  = '' 
      this.db.current_locate('')
      // this.address_info.country = 'United States';
    }else if(this.address_type == "Edit"){
      this.address_info.first_name = this.address_info.first_name ? this.address_info.first_name : '';
      this.address_info.last_name = this.address_info.last_name ? this.address_info.last_name : '';
      this.address_info.address = this.address_info.address ? this.address_info.address : '';
  		this.address_info.city = this.address_info.city ? this.address_info.city : '';
      this.address_info.state = this.address_info.state ? this.address_info.state : '';
  		this.address_info.zipcode = this.address_info.zipcode ? this.address_info.zipcode : '';
      this.address_info.house_type = this.address_info.house_type ? this.address_info.house_type : 'Individual';
      this.address_info.country =  this.address_info.country ? this.address_info.country : '';
      this.address_info.landmark = this.address_info.landmark ? this.address_info.landmark : '';
      this.address_info.door_no = this.address_info.door_no ? this.address_info.door_no : '';
      this.address_info.is_default = this.address_info.is_default == 0 ? false : true;
      this.db.location_info.address  = this.address_info.address ? this.address_info.address : '';
      this.db.location_info.latitude = this.address_info.latitude ? Number(this.address_info.latitude) :''
      this.db.location_info.longitude = this.address_info.longitude ? Number(this.address_info.longitude) :''
      this.db.located.next('located');
      // let locations = new google.maps.LatLng(this.address_info.latitude,this.address_info.longitude);
      // this.db.decode(locations);
    }

    this.address_form = this.formBuilder.group({
      first_name: new FormControl(
        this.address_info.first_name || "",
        Validators.required
      ),
      last_name: new FormControl(
        this.address_info.last_name || "",
        Validators.required
      ),
      address: new FormControl(
        this.address_info.address || "",
        Validators.required
      ),
      city: new FormControl(this.address_info.city || "", Validators.required),
      state: new FormControl(
        this.address_info.state || "",
        Validators.required
      ),
      country: new FormControl(
        this.address_info.country || "",
        Validators.required
      ),
      zipcode: new FormControl(
        this.address_info.zipcode || '',[
        Validators.required,Validators.pattern(this.isValidPostalCode(this.db.currency))]),
      
      house_type : new FormControl((this.address_info.house_type || ''), Validators.required),
      landmark : new FormControl((this.address_info.landmark || '')),
      door_no : new FormControl((this.address_info.door_no || '')),
      // door_no : new FormControl((this.address_info.door_no || ''), Validators.required),
      // phone: new FormControl((this.address_info.phone || ''), [Validators.required, Validators.pattern(this.phone_pattern)])
        // this.address_info.state = 'Tamil Nadu';
    });

    // Validators.pattern('[0-9]{6}')
    if (this.country_list.length == 0 && this.address_info.country) {
      this.country_list = [{ name: this.address_info.country }];
      this.address_form.value.country = this.address_info.country;
    }
    if (this.states_list.length == 0 && this.address_info.state) {
      this.states_list = [{ name: this.address_info.state }];
      this.address_form.value.state = this.address_info.state;
    }
  }

  ngAfterViewInit() {
    if(!this.db.ismobile)
      this.db.getPlaceAutocomplete(this.addresstext.nativeElement,'');
  }

  @HostListener('window:resize', ['$event'])
  resize(event){
    let size = event.target.innerWidth;
      this.db.check_mobile();
  }

  get validation(){
    return this.address_form.controls;
  }

  // get phone(){
  //   return this.address_form.get('phone')
  // }
    
  get_country_list() {
    // console.log("li", this.address_info);
    this.db.domain_get_country_list().subscribe(
      (res: any) => {
        // console.log("country", res.message);
        this.country_list = res.message;
        if (this.address_info.country) {
          this.address_form.value.country = this.address_info.country;
        }
        else
          this.address_info.country = this.country_list.length > 0 ?this.country_list[0].name: null

        this.get_state_list();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  isValidPostalCode(countryCode) {
    var postalCodeRegex;
    switch (countryCode) {
        case "USD":
            postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
            break;
        case "CA":
            postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
            break;
        default:
            postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
    }
    return postalCodeRegex;
    // return postalCodeRegex.test(postalCode);
}


format_phone(ev:any) {
     
  let new_string = '';
  if(this.address_form.value.phone && this.address_form.value.phone.length > 0) {
    let phone = this.address_form.value.phone.replace(/-/g, '');
    for(var i = 0; i < phone.length; i++) {
      if((i < 3) || (i > 3 && i < 6) || (i > 6 && i < 10)) {
        new_string += phone[i];
      } else if((i == 3) || (i == 6) && phone[i] != '-') {
        new_string += '-' + phone[i];
      }
    }
  }

   this.address_form.get('phone').setValue(new_string)

}

// format_zipcode(ev){
//   console.log(ev)
//   // this.address_form = this.formBuilder.group({
//   //       phone: new FormControl(new_string || '', [Validators.required, Validators.pattern(this.isValidPostalCode(this.db.currency))])
//   //     })
// }

  get_state_list() {
    this.db.domain_get_states_lists(this.address_info.country).subscribe(
      (r: any) => {
        this.states_list = r.message;
        if (this.address_info.state) {
          this.address_form.value.state = this.address_info.state;
        }
        else
          this.address_info.state = this.states_list.length > 0 ?this.states_list[0].name: null
      },
      (error) => {
        console.log(error);
      }
    );
  }

  value_changed(evt:any) {
    if (evt.detail.value) {
      this.address_info.country = evt.detail.value;
      this.get_state_list();
    }
  }


  insert_address1() {
    this.submitted = true;
    if (this.address_form.valid) {
      // console.log("li", this.address_info);
      this.address_info = this.address_form.value;
      this.submitted = true;
      this.address_info.customer = this.customer_id.name;
      this.address_info.addr1 = this.address_form.value.address;
      this.address_info.pincode = this.address_info.zipcode;
      this.address_info.city = this.address_form.value.city;
      // console.log(this.address_info, "-------------")
      this.db.insert_address({ data: JSON.stringify(this.address_info) }, 1).subscribe((res: any) => {
        // console.log("insert", res);
        this.modalCtrl.dismiss();
        if (res.message.status == "failed") {
          this.db.alert(res.message.message)
        }
      });
    }
  }

  // house_type
  insert_address() {
    console.log(this.address_form,'form values')
    console.log(this.address_info,'info values')
     this.submitted = true;
      this.zipcode.setValue(this.db.location_info.zipcode)
      this.city.setValue(this.db.location_info.city)
      this.address_info.pincode = this.db.location_info.zipcode;
      this.address_info.latitude = this.db.location_info.latitude
      this.address_info.longitude = this.db.location_info.longitude
      this.address_info.city = this.db.location_info.city
      this.address_info.customer = localStorage['customerRefId'];
      this.address_info.addr1 = this.db.location_info.address;
      this.address_info.door_no = this.address_form.value.door_no;
      this.address_info.landmark = this.address_form.value.landmark;
      
    // console.log(this.address_info)
    if(this.address_form.valid) {
      this.db.insert_address({ data: JSON.stringify(this.address_info) }, 1).subscribe((r: any) => { 
        this.modalCtrl.dismiss();
        if (r.message.status == "failed") {
          this.db.alert(r.message.message)
        }
      }, error => {  console.log(error); })
    }
  }



  dismiss_modal() {
    this.modalCtrl.dismiss({ status: "closed" });
  }

  close(){
    this.modalCtrl.dismiss();
  }

  // edit_address() {
  //   console.log(this.address_form.value)
  //   console.log(this.address_info);
  //   console.log(this.address_form.value['first_name'])

  //   this.submitted = true;
  //   this.address_info.customer = localStorage.customerRefId;
  //   this.address_info.first_name = this.address_form.value['first_name'];
  //   this.address_info.last_name = this.address_form.value['last_name'];
  //   this.address_info.addr1 = this.address_form.value.address;
  //   this.address_info.pincode = this.address_form.value.zipcode;
  //   this.address_info.city = this.address_form.value.city;
  //   this.address_info.state = this.address_form.value.state;
  //   this.address_info.country = this.address_form.value.country;
  //   this.address_info.house_type = this.address_form.value.house_type;
  //   this.address_info.phone = this.address_form.value.phone;
  //   this.address_info.landmark = this.address_form.value.landmark;
  //   this.address_info.door_no = this.address_form.value.door_no;
  //   this.address_info.is_default = this.address_form.value.is_default;
    
  //   if(this.address_form.valid) {
  //     this.db.update_address({'data': JSON.stringify(this.address_info)})
  //     .subscribe((r: any) => {
  //       this.modalCtrl.dismiss({'status': 'success'});
  //     }, error => {
  //       console.log(error);
  //     })
  //   }
  // }

  
  get landmark(){
    return this.address_form.get('landmark');
  } 
  
  get door_no(){
    return this.address_form.get('door_no');
  } 

  get first_name(){
    return this.address_form.get('first_name');
  } 

  get last_name(){
    return this.address_form.get('last_name');
  } 
  
  get address(){
    return this.address_form.get('address');
  }

  get zipcode(){
    return this.address_form.get('zipcode')
  }

  get phone(){
    return this.address_form.get('phone')
  }

  get city(){
    return this.address_form.get('city')
  }

  get country(){
    return this.address_form.get('country')
  }

  get house_type(){
    return this.address_form.get('house_type')
  }

  get state(){
    return this.address_form.get('state')
  }

  get is_default(){
    return this.address_form.get('is_default')
  }


  edit_address() {
    this.submitted = true;
    // if (this.address_form.valid) {
    let dataArray = {
      name: this.address_info.name,
      address: this.address_form.value.address,
      city: this.address_form.value.city,
      first_name: this.address_form.value.first_name,
      state: this.address_form.value.state,
      last_name: this.address_form.value.last_name,
      zipcode: this.address_form.value.zipcode,
      pincode: this.address_form.value.zipcode,
      addr1: this.address_form.value.address,
      phone: this.customer_data.phone,
      door_no:this.address_form.value.door_no,
      landmark:this.address_form.value.landmark,
      // phone: "9952375575"
     customer: this.customer_data.name,
    };
    // console.log("dataarray", dataArray);
    let datas = {
      data: JSON.stringify(dataArray),
    };
      if (this.address_form.valid) {
        this.db.update_address(datas, 1).subscribe((res: any) => {
          // console.log("edit working", res);
          // console.log(this.db.customer_adr_id)
          if(this.db.customer_adr_id && (res.message.name == this.db.customer_adr_id.name)){
            this.db.customer_adr_id = res.message;
          }
          this.db.added_animate.next('Address Updated successfully');
          this.modalCtrl.dismiss();
        },
          (error) => {
            console.log(error);
          }
        );
      }
    }
  // }
}
